import * as React from 'react';
import { GraphQLClient, ClientContext } from "graphql-hooks";
var client = new GraphQLClient({
  url: process.env.GRAPHQL_SERVER,
  headers: {
    accesskey: process.env.GRAPHQL_ACCESS_KEY
  }
});
export var GraphQLClientProvider = function GraphQLClientProvider(_a) {
  var children = _a.children;
  return React.createElement(ClientContext.Provider, {
    value: client
  }, children);
};